import { BasicParallelEnumerable } from "../BasicParallelEnumerable.js";
export const where = (source, predicate) => {
    const generator = async () => {
        const values = await source.toArray();
        return values.filter(predicate);
    };
    return new BasicParallelEnumerable({
        generator,
        type: 0,
    });
};
